import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import ServicesLanding from "../views/ServicesLanding";
import ServiceDetail from "../views/ServiceDetail";

export default function Gallery(props) {
  const appContext = useContext(AppContext);

  const [view, setView] = useState(null);

  async function init() {
    //run initializations here
  }

  function getView() {
    if (
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <ServicesLanding />;
    } else if (appContext.navSubItem) {
      // Handle service detail page
      return <ServiceDetail serviceSlug={appContext.navSubItem} />;
    }

    return null;
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const _view = getView();
    if (_view) {
      setView(_view);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  //return desired view
  return view;
}
